module.exports = __webpack_public_path__ + "img/login-vector-shrinked.05fc08b9.webp";